import React from 'react';
import { Option } from 'ts-option';
import { QueryMetaSuccess } from 'common/explore_grid/redux/store';
import { ExportFormat } from 'common/downloadLinks';
import DownloadWarning from './DownloadWarning';
import { RowCountType } from 'common/providers/RowCount';

import { useSafeRowCount } from 'common/providers/RowCount/RowCountUtils';

/** Wrapper component that connects DownloadWarning to RowCountProvider */
const ProviderDownloadWarning: React.FC<{
  selectedFiltered: boolean;
  isFileDownloadSelected: boolean;
  isVisualization: boolean;
  selectedResourceValue: ExportFormat | undefined;
  meta?: Option<QueryMetaSuccess>;
}> = (props) => {
  const { value: totalRowCount } = useSafeRowCount(RowCountType.Total);
  const { value: filteredRowCount } = useSafeRowCount(RowCountType.Filtered);

  return (
    <DownloadWarning
      {...props}
      rowCountAll={totalRowCount ?? undefined}
      rowCountFiltered={filteredRowCount ?? undefined}
    />
  );
};

export default ProviderDownloadWarning;
